const settingActions = {
    CHANGE_TOOL:"CHANGE_TOOL",
    CHANGE_COLOR: "CHANGE_COLOR",
    CHANGE_BACKGROUND: "CHANGE_BACKGROUND",
    CHANGE_STROKE_FILL: "CHNAGE_STROKE_FILL",
    CHNAGE_STROKE_WIDTH:"CHANGE_STROKE_WIDTH",
    CHNAGE_STROKE_STYLE: "CHNAGE_STROKE_STYLE",
}

export default settingActions